module.exports = __webpack_public_path__ + "img/37.841145d2.jpg";